/**
 * `modules/switcher.js`
 * - 特定領域の画像等切り替え処理
 *
 * 使用方法:
 * - import {initSwitcher} from "../modules/switcher.js";
 * - initSwitcher();
 *
 */


export function initSwitcher(button, container, listeners) {
  // スイッチャーのグループを取得（ない場合は `default` とする）
  const switcherGroup = button.dataset.switcherGroup || "default";

  const activateImage = () => {
    const targetId = button.dataset.switcherTarget;
    if (!targetId) return;

    // 同じグループの要素を取得
    const images = container.querySelectorAll(`[data-switcher-id][data-switcher-group="${switcherGroup}"]`);

    // 全ての `is-open` を削除
    images.forEach((image) => image.classList.remove("is-open"));

    // `data-switcher-id` が一致する要素に `is-open` を付与
    const targetImage = container.querySelector(`[data-switcher-id="${targetId}"][data-switcher-group="${switcherGroup}"]`);
    if (targetImage) {
      targetImage.classList.add("is-open");
    }
  };

  button.addEventListener("mouseover", activateImage);
  listeners.push([button, "mouseover", activateImage]);
}


/**
 * sample html

  <!-- Group A -->
  <div class="switcher-container">
    <button data-action="switcher" data-switcher-target="image1" data-switcher-group="groupA">Image 1</button>
    <button data-action="switcher" data-switcher-target="image2" data-switcher-group="groupA">Image 2</button>

    <img src="image1.jpg" data-switcher-id="image1" data-switcher-group="groupA" class="is-open">
    <img src="image2.jpg" data-switcher-id="image2" data-switcher-group="groupA">
  </div>

  <!-- Group B -->
  <div class="switcher-container">
    <button data-action="switcher" data-switcher-target="image3" data-switcher-group="groupB">Image 3</button>
    <button data-action="switcher" data-switcher-target="image4" data-switcher-group="groupB">Image 4</button>

    <img src="image3.jpg" data-switcher-id="image3" data-switcher-group="groupB" class="is-open">
    <img src="image4.jpg" data-switcher-id="image4" data-switcher-group="groupB">
  </div>

 * */